/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListTicketStatus } from '../models/api-response-list-ticket-status';
import { ApiResponsePageTicketStatus } from '../models/api-response-page-ticket-status';
import { ApiResponseTicketStatus } from '../models/api-response-ticket-status';
import { createStatus } from '../fn/ticket-status-api/create-status';
import { CreateStatus$Params } from '../fn/ticket-status-api/create-status';
import { getAllStatus1 } from '../fn/ticket-status-api/get-all-status-1';
import { GetAllStatus1$Params } from '../fn/ticket-status-api/get-all-status-1';
import { getStatusByRef } from '../fn/ticket-status-api/get-status-by-ref';
import { GetStatusByRef$Params } from '../fn/ticket-status-api/get-status-by-ref';
import { searchStatus } from '../fn/ticket-status-api/search-status';
import { SearchStatus$Params } from '../fn/ticket-status-api/search-status';
import { updateStatus } from '../fn/ticket-status-api/update-status';
import { UpdateStatus$Params } from '../fn/ticket-status-api/update-status';

@Injectable({ providedIn: 'root' })
export class TicketStatusApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateStatus()` */
  static readonly UpdateStatusPath = '/v1/api/ui/status-ticket/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStatus$Response(params: UpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketStatus>> {
    return updateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStatus(params: UpdateStatus$Params, context?: HttpContext): Observable<ApiResponseTicketStatus> {
    return this.updateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketStatus>): ApiResponseTicketStatus => r.body)
    );
  }

  /** Path part for operation `searchStatus()` */
  static readonly SearchStatusPath = '/v1/api/ui/status-ticket/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStatus$Response(params: SearchStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageTicketStatus>> {
    return searchStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStatus(params: SearchStatus$Params, context?: HttpContext): Observable<ApiResponsePageTicketStatus> {
    return this.searchStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePageTicketStatus>): ApiResponsePageTicketStatus => r.body)
    );
  }

  /** Path part for operation `createStatus()` */
  static readonly CreateStatusPath = '/v1/api/ui/status-ticket/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStatus$Response(params: CreateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketStatus>> {
    return createStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStatus(params: CreateStatus$Params, context?: HttpContext): Observable<ApiResponseTicketStatus> {
    return this.createStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketStatus>): ApiResponseTicketStatus => r.body)
    );
  }

  /** Path part for operation `getStatusByRef()` */
  static readonly GetStatusByRefPath = '/v1/api/ui/status-ticket/get/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStatusByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatusByRef$Response(params: GetStatusByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketStatus>> {
    return getStatusByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStatusByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatusByRef(params: GetStatusByRef$Params, context?: HttpContext): Observable<ApiResponseTicketStatus> {
    return this.getStatusByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketStatus>): ApiResponseTicketStatus => r.body)
    );
  }

  /** Path part for operation `getAllStatus1()` */
  static readonly GetAllStatus1Path = '/v1/api/ui/status-ticket/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllStatus1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStatus1$Response(params?: GetAllStatus1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTicketStatus>> {
    return getAllStatus1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllStatus1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStatus1(params?: GetAllStatus1$Params, context?: HttpContext): Observable<ApiResponseListTicketStatus> {
    return this.getAllStatus1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTicketStatus>): ApiResponseListTicketStatus => r.body)
    );
  }

}
